import BrandedSuccessLottie from "@/components/ui/BrandedSuccessLottie";
import { useNavigate } from "@tanstack/react-router";
import { ArrowRightIcon, XIcon } from "lucide-react";
import { Button } from "../../ui/button/button";

const WithdrawSuccessPage = () => {
	const navigate = useNavigate();

	const goHome = () => {
		navigate({ to: "/main/home" });
	};
	return (
		<div className="relative flex flex-col items-center  bg-white text-textDark h-[100dvh] text-center space-y-4 p-4">
			<XIcon
				className="absolute right-0 -top-2"
				role="button"
				onClick={goHome}
			/>
			<div className="max-w-64 mx-auto ">
				<BrandedSuccessLottie />
			</div>
			<h1 className="text-4xl font-bold text-textDark">
				Whoo! Your funds
				<br />
				are in transit.
			</h1>
			<div>
				<p className="pt-3 text-sm font-medium text-textDark">
					Congratulations!
				</p>
				<p className="pt-1 text-sm font-medium text-textDark">
					You've withdrawn funds to your bank.
				</p>
			</div>

			<Button
				className="w-full text-base font-bold text-white rounded-xl"
				onClick={goHome}
			>
				View Balance
				<ArrowRightIcon className="w-5 h-5" />
			</Button>
		</div>
	);
};

export default WithdrawSuccessPage;
